export default __webpack_public_path__ + "static/media/dummy_img.c241d324.svg";